

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
  googleTrackingID: "",
};

//Home Page
const greeting = {
  title: "Greetings...",
  title2: "Rahul",
  logo_name: "Eric",
  nickname: "Eric lonewolf",
  full_name: "Rahul Giridharan Iyengar",
  subTitle:
    "Aspiring Inventor, Robotics enthusiast, Computer geek, Life hacker...Learning new things, one step at a time",
  resumeLink:
    "https://drive.google.com/file/d/1mla-puj1q-cj84pqNL2w0BH6ujS_HBDr/view?usp=sharing",
  mail: "mailto:rahul.g.iyengar@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/RahulGIyengar",
  linkedin: "https://www.linkedin.com/in/rahul-iyengar-09397a166/",
  gmail: "rahul.g.iyengar@gmail.com",
  
};

const skills = {
  data: [
    {
      title: "Roboticist",
      fileName: "Roboticist",
      skills: [
        "➡ I basically work with almost everything. Electronics, Web dev, ML, Graphic Designing, you name it :)",
        "➡ My interests however lie in the fields of Deep Learning, Swarm Algorithms, Multi Robot Systems, Computer Vision, Robot path planning and control. Most of my projects reflect these",
        "➡ I spend my free time tinkering with electronics, learning new stuff. There is no greater joy than seeing your creations come to life :)",
        "➡ My hobbies include, reading books (fantasy,sci-fi ones), listening to instrumentals and gaming :) ",
        
      ],
      softwareSkills: [
        // causing screen tearing issues
        {
          skillName: "ROS",
          logo_path: "ros.svg",
          style: {
            color: "#0865A6",
          },
        },
        {
          skillName: "Matlab",
          logo_path: "m.png",
          style: {
            color: "#207297",
          },
        },
        {
          skillName: "Raspberry Pi",
          logo_path: "rpi.svg",
          style: {
            color: "#4479A1",
          },
        },
        
        {
          skillName: "Tensorflow",
          logo_path: "t.svg",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "TinyML",
          logo_path: "tml.svg",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Arduino",
          logo_path: "arduino.svg",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Espressif",
          logo_path: "esp.svg",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Fusion 360",
          logo_path: "f360.svg",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Adobe Illustrator",
          logo_path: "ai.svg",
          style: {
            color: "#439743",
          },
        },
        
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        
        {
          skillName: "Android",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },        
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          logo_path: "",
          style: {
            color: "#FF9900",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "SRM Institute of Science and Technology",
      subtitle: "BTech Mechatronics Engineering with specialization in Robotics",
      logo_path: "srm.png",
      alt_name: "SRMIST",
      duration: "2018 - 2022",
      descriptions: [
        "➡ As part of my syllabus, studied core programming concepts like Data Structures, Algorithms, etc",
        "➡ Programming languages learnt: C, C++, Python",
        "➡ Softwares learnt: Arduino IDE, Fusion 360, ROS, MATLAB, ",
        "➡ Concepts learnt: Path planning and control of robots, Computer vision for Robotics, Deep learning Algorithms using Tensorflow",
        "➡ I have implemented several projects based on what I've learnt under my course. ",
      ],
      website_link: "https://www.srmist.edu.in/",
    },
    {
      title: "Royal College of Science and Commerce",
      subtitle: "High School 12th Grade",
      logo_path: "royal.png",
      alt_name: "SSGC",
      duration: "2016 - 2018",
      descriptions: [
        "➡ Obtained Higher Secondary School certificate, Maharashtra board, India",
        "   for Physics, Chemistry, Maths, English and Computer Science ( Hardware and Software )",
        "➡ Participated and completed robotics Level 1, 2, 3",
      ],
      website_link: "http://www.royalcollegedombivli.com/",
    },
  ],
};

const certifications = {
  certifications: [
    
    {
      title: "TensorFlow Developer Specialization",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning.ai.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/certificate/CJLUQYNFPLQE",
      alt_name: "course",
      color_code: "#ffffff",
    },
    {
      title: "Convolutional Neural Networks in Tensorflow",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning.ai.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/2TKF3GHADZTY",
      alt_name: "course",
      color_code: "#ffffff",
    },
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning.ai.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/JQC8P99XTPR3",
      alt_name: "course",
      color_code: "#ffffff",
    },
    { 
      title: "MLH Local Hack Day: Build",
      subtitle: "Major League Hacking",
      logo_path: "mlh-logo.svg",
      certificate_link:
        "https://drive.google.com/file/d/1_LL8j_pF63ev098ZXFP0_48TslRPc-lx/view?usp=sharing",
      alt_name: "Google",
      color_code: "#ffffff",
    },
    {
      title: "M0001: MongoDB Basics",
      subtitle: "MongoDB University",
      logo_path: "MongoDB_Logo.svg",
      certificate_link:
        "https://drive.google.com/file/d/1xeQSw-CZ3jV4dGjsI8y-Bl17C8ZFciD3/view?usp=sharing",
      alt_name: "MongoDB University",
      color_code: "#47A048",
    },
    { 
      title: "Introduction to Tensorflow for AI, ML, and DL",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning.ai.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/CH886CDQKSS8",
      alt_name: "Google",
      color_code: "#ffffff",
    },
    { 
      title: "Natural Language Processing in Tensorflow",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning.ai.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/EVEB4BEC7EJL",
      alt_name: "Google",
      color_code: "#ffffff",
    },
    { 
      title: "Sequences, Time Series and Prediction",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning.ai.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/8TTGKBPK3AV8",
      alt_name: "Google",
      color_code: "#ffffff",
    },
    { 
      title: "Introduction to Internet of Things and Embedded Systems",
      subtitle: "University of California, Irvine",
      logo_path: "Asset 3.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/BJ92YYBU9U2P",
      alt_name: "Google",
      color_code: "#ffffff",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I have interned at two companies. Apart from that, I have held various roles in my universitiy's Student Clubs and Research Lab.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "R&D Intern",
          company: "MEL Systems and Services Ltd",
          company_url: "https://www.melss.com/",
          logo_path: "melss.png",
          duration: "Jun 2021 - Nov 2021",
          location: "Part time-Office",
          description:
          `Led a team of 4 under New part development department and worked on the project "Smart Utility Controller"
          Responsible for developing a proprietary BLE-WIFI link along with developing hardware schematic and Firmware for “Smart Utility Controller” project, 
          that controls industrial cobots, with scheduled on/off, automated tasks,etc.
          `,
          color: "#0071C5",
        },
        {
          title: "AI Intern",
          company: "Indo German Tool Room, Indore ",
          company_url: "http://www.igtr-indore.com/",
          logo_path: "igtr.png",
          duration: "Jan 2021 - July 2021",
          location: "Part time-Online",
          description:
          `Worked with my team to develop tool wear monitoring system using an Adaptive Neuro-Fuzzy Inference System (ANFIS) model.
          `,
          color: "#ee3c26",
        },
        {
          title: "Student Researcher",
          company: "SIIC, SRMIST",
          company_url: "https://www.srmiic.com/",
          logo_path: "siic.png",
          duration: "Dec 2019 - Dec 2020",
          location: "Part time-Online",
          description:
          ` Responsible for developing DigiFAB Smart Locker that uses Facial Recognition and RFID ID card to allocate/deallocate lockers for students in FABLAB. Received funding upto 2 lakhs INR.
          Developed Object detection model to detect students wearing id , using Tensorflow Object Detection API
          Worked on Smart Surveillance Security, and automated system that keeps track of people entering and leaving FabLab
          `,
          color: "#ee3c26",
        },
        {
          title: "Student Researcher",
          company: "SRM Center of Excellence in IOT",
          company_url: "https://www.srmiic.com/",
          logo_path: "srm1.png",
          duration: "Mar 2020 - Dec 2020",
          location: "Part time-Online",
          description:
          ` Worked on a “Smart Drone Navigation” System that navigates around college campus for surveillance purposes. 
          Automated Docking system to charge the drone was also proposed. Funding upto 2 lakhs INR.
          `,
          color: "#ee3c26",
        },
        {
          title: "Robotics Lead, Core technical Member",
          company: "The Project Team, SRMIST",
          company_url: "https://theprojectteam.in/",
          logo_path: "tpt.png",
          duration: "2018 - 2022",
          location: "Full time",
          description:
          ` Conducted workshop – Industry 4.0 with hands-on projects on Basics of IoT.
          School Outreach Program to teach students basics of programming, electronics with hands-on learning.
          Formed SRM Arduino User Group and acted as its Mentor.
          Took incharge of robotics domain, and heading projects related to robotics.
          `,
          color: "#ee3c26",
        },
        {
          title: "Core technical Member",
          company: "Association of Mechatronics Engineers, SRMIST",
          company_url: "https://sites.google.com/view/srmistame/home",
          logo_path: "ame.png",
          duration: "2018 - 2022",
          location: "Full time",
          description:
          ` Organized various sessions on MATLAB, ROS for Robotics and Deep Learning using Tensorflow.
          Part of the team that organized Mock Interview and GD sessions for 3rd and 4th year students.
          `,
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Core Member",
          company: "NSS, SRMIST",
          company_url: "",
          logo_path: "nss.png",
          duration: "2018 - 2022",
          location: "On site",
          description:
          `Led and organized anti-drug addiction campaign
            along with school of public health, SRM IST
            Led a team of 5 in educating the students of a
            Municipal school on importance of hygiene.
            Participated in Mahindra city tree plantation drive 
            `,
          color: "#4285F4",
        },
        {
          title: "GitHub Student Developer",
          company: "GitHub",
          company_url: "https://github.com/",
          logo_path: "github.png",
          duration: "2018 - Present",
          location: "Work from Home",
          description:
          "Contribute to Open Source Community and Open Source Project.",
          color: "#040f26",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects make use of a vast variety of latest technology tools. My expertise and intrests lie in the fields of Artificial Intelligence, Computer Vision, Swarm systems,Robotics and IoT. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Rahul.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Coming soon",
    link: "",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      name: "Air-Mouse",
      url: "https://github.com/RahulGIyengar/Air-Mouse",
      description: "Hand gesture and finger position is detected using Opencv and cursor is moved accordingly",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "1",
      name: "Hand pose detection using SRN",
      url: "https://github.com/RahulGIyengar/handpose",
      description:
        "Implementation of Stacked regression Neural network to find realtime hand pose using spatial structure obtained from depth map generated using kinect camera. Hands17 dataset was used",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
    },
    {
      id: "2",
      name: "Farmer Assistant- Weed detection and Crop, pesticide recommendation",
      url: "https://github.com/RahulGIyengar/BitCamp-hackathon",
      description:
        "A webapp that takes climate of the region and images of the farm as input and recommends pesticides. YOLOV3 model was used for Weed detection",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "TypeScript",
          iconifyClass: "logos-typescript",
        },
      ],
    },
    {
      id: "3",
      name: "DigiFAB Smart Locker and Security System",
      url: "",
      description:
        "Smart Lockers and security system developed for Fablab, a research lab in SRMIST. Uses Face recognition model and id card recognition, coupled with rfid id card detection, and data logging to mongodb database",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
      ],
    },
    {
      id: "4",
      name: "Smart Drone Navigation System",
      url: "",
      description:
      `Research project funded by SRM center of excellence in iot. “Smart Drone Navigation” System that navigates around college campus for surveillance purposes. 
        Automated Docking system to charge the drone was also proposed`,
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "C++",
          iconifyClass: "simple-icons:cplusplus",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      id: "5",
      name: "Smart Utility Controller",
      url: "",
      description:
        "Firmware for Smart Utility Controller project developed for MELSS.",
      languages: [
        {
          name: "C++",
          iconifyClass: "simple-icons:cplusplus",
        },
        {
          name: "Firebase",
          iconifyClass: "logos-firebase",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
      ],
    },
    {
      id: "6",
      name: "Tool Wear Monitoring System",
      url: "",
      description:
        "Research on Tool wear monitoring system using an Adaptive Neuro-Fuzzy Inference System (ANFIS) model, done at IJTR, Indore",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
      ],
    },
    {
      id: "7",
      name: "DocAssist- Medical Database system",
      url: "",
      description:
        "Medical database system consists of one central database. medicine alternatives for patients and Virtual Patient records for doctors",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
        {
          name: "CSS3",
          iconifyClass: "vscode-icons:file-type-css",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "MongoDB",
          iconifyClass: "simple-icons:mongodb",
        },
      ],
    },
    {
      id: "8",
      name: "Swarm Link",
      url: "",
      description:
        "A Swarm communication algorith based on ESP NOW protocol",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "C++",
          iconifyClass: "simple-icons:cplusplus",
        },
      ],
    },
    {
      id: "9",
      name: "Battery Charging system for drones",
      url: "",
      description:
        "Under development. Working on a system to charge autonomous drones without human intervention ",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "C++",
          iconifyClass: "simple-icons:cplusplus",
        },
      ],
    },
    {
      id: "10",
      name: "Automated Guided Vehicle",
      url: "",
      description:
        "2 wheel differential mobile robot with ultrasonic sensor and ir led array, that follows black strip tape, and avoids obstacles on the path.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "C++",
          iconifyClass: "simple-icons:cplusplus",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
